import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validatePatientProfile = (data, setError) => {
  /** Required:
   * username
   * password
   */

  var isValid = true;

  if (data.last_name === "") {
    handleValidationChange("last_name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("last_name", false, setError);
  }

  if (data.first_name === "") {
    handleValidationChange("first_name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("first_name", false, setError);
  }
  // if (data.birthdate === "") {
  //   handleValidationChange("birthdate", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("birthdate", false, setError);
  // }
  // if (data.address === "") {
  //   handleValidationChange("address", true, setError);
  //   isValid = false;
  // } else {
  //   handleValidationChange("address", false, setError);
  // }
  if (data.sex === "") {
    handleValidationChange("sex", true, setError);
    isValid = false;
  } else {
    handleValidationChange("sex", false, setError);
  }

  // Philhealth membership validation
  if (data.ph_check) {
    // patient_type: "member" | "dependent"
    if (
      data.phic_membership_type !== "member" &&
      data.phic_membership_type !== "dependent"
    ) {
      handleValidationChange("phic_membership_type", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_membership_type", false, setError);
    }

    // member_pin: string (12 characters)
    if (data.phic_pin === "" || data?.phic_pin?.length !== 12) {
      handleValidationChange("phic_pin", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_pin", false, setError);
    }

    // dependent_pin?: string (12 characters) if patient_type is "dependent"
    if (
      data.phic_membership_type === "dependent" &&
      (data.phic_dependent_pin === "" || data.phic_dependent_pin.length !== 12)
    ) {
      handleValidationChange("phic_dependent_pin", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_dependent_pin", false, setError);
    }

    // first_name: string
    if (data.phic_first_name === "") {
      handleValidationChange("phic_first_name", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_first_name", false, setError);
    }

    // last_name: string
    if (data.phic_last_name === "") {
      handleValidationChange("phic_last_name", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_last_name", false, setError);
    }

    // birthdate: string
    if (data.phic_birthdate === "") {
      handleValidationChange("phic_birthdate", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_birthdate", false, setError);
    }

    // // mobile_number: string (11 characters)
    // if (data.ph_mobile_number === "" || data.ph_mobile_number.length !== 11) {
    //   handleValidationChange("ph_mobile_number", true, setError);
    //   isValid = false;
    // } else {
    //   handleValidationChange("ph_mobile_number", false, setError);
    // }

    // enlistment_date: string
    if (data.phic_enlistment_date === "") {
      handleValidationChange("phic_enlistment_date", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_enlistment_date", false, setError);
    }

    // enlistment_status: "active" | "cancelled" | "transferred"
    if (
      data.phic_enlistment_status !== "active" &&
      data.phic_enlistment_status !== "cancelled" &&
      data.phic_enlistment_status !== "transferred"
    ) {
      handleValidationChange("phic_enlistment_status", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_enlistment_status", false, setError);
    }

    // package_type: "Konsulta Package" | "PCB1" | "Expanded PCB"
    if (
      data.phic_package_type !== "Konsulta Package" &&
      data.phic_package_type !== "PCB1" &&
      data.phic_package_type !== "Expanded PCB"
    ) {
      handleValidationChange("phic_package_type", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_package_type", false, setError);
    }

    // atc: string
    if (data.phic_atc === "") {
      handleValidationChange("phic_atc", true, setError);
      isValid = false;
    } else {
      handleValidationChange("phic_atc", false, setError);
    }
  }

  return isValid;
};

export const validatePatientSearch = (data) => {
  var isNull = false;

  if (data.length === 0) {
    isNull = true;
  } else if (!data.patient_no || data.patient_no === "") {
    if (
      !data.last_name ||
      !data.birthdate ||
      data.last_name === "" ||
      data.birthdate === ""
    ) {
      isNull = true;
    }
  }

  return isNull;
};
